import React, {useEffect, useState} from 'react';
import ClientBillingButtons from './ClientBillingButtons';
import ClientBillingGraph from './ClientBillingGraph';
import styles from './ClientBilling.module.css';
import {clientFirstPaymentAPI, nextPayAPI, paymentBarGraphAPI, paymentTypeAPI} from "../../../services/client";
import {GetGraphResponseData} from "../../../types/admin";

interface BillingInfo {
    amount: number;
    payday: Date;
    paymentType: string;
}

// 클라이언트 결제 정보
const ClientBilling = () => {
    const [loading, setLoading] = useState(true);
    const [billingInfo, setBillingInfo] = useState<BillingInfo>();
    const [graphData, setGraphData] = useState<GetGraphResponseData[]>();

    const fetchData = async () => {
        try {
            setLoading(true);
            // 다음 결제 정보 조회 API
            const info = await nextPayAPI();
            // 클라이언트 결제 방법 조회 API
            const type = await paymentTypeAPI();
            // 클라이언트 첫 결제 연도 조회 API
            const first = await clientFirstPaymentAPI();
            setBillingInfo({
                amount: info?.amount,
                payday: info?.paidAt,
                paymentType: type

            });
            // 클라이언트 결제 통계 그래프 API
            const table = await paymentBarGraphAPI(first);
            setGraphData(table);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    // 연월 형식 YYYY-MM으로 변경
    const formatYearMonth = (date: string | number | Date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    };

    const onClose = () => {
        fetchData(); //데이터 최신화
    }

    // 클라이언트 결제 통계 그래프
    const paymentView = () => {
        if (!billingInfo?.paymentType) return; //클라이언트 결제 방법 등록하지 않은 경우 출력 X
        return (
            <div className={styles.graphSection}>
                {/*클라이언트 결제 통계 그래프*/}
                <ClientBillingGraph
                    graph={graphData}
                    initialYear={new Date().getFullYear()}
                    onYearChange={(year) => console.log('Year changed:', year)}
                />
            </div>
        )
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.container}>
            {/* 상단 정보 카드 섹션 */}
            {!loading && billingInfo && (
                <div className={styles.infoCards}>
                    {/*다음 결제액*/}
                    <div className={styles.card}>
                        <span className={styles.label}>다음 결제액</span>
                        <span className={styles.value}>{billingInfo.amount.toLocaleString() || "0"}원</span>
                    </div>
                    {/*다음 결제일*/}
                    <div className={styles.card}>
                        <span className={styles.label}>다음 결제일</span>
                        <span
                            className={styles.value}>{billingInfo.payday ? billingInfo.payday.toString().split("T")[0] : "-"}</span>
                    </div>
                    {/*클라이언트 등록 결제 방법*/}
                    <div className={styles.card}>
                        <span className={styles.label}>등록 결제방법</span>
                        <span className={styles.value}>{billingInfo.paymentType || "미등록"}</span>
                    </div>
                </div>
            )}

            <div className={styles.buttonSection}>
                {/*결제 기능 버튼*/}
                <ClientBillingButtons
                    paymentType={billingInfo?.paymentType || "미등록"}
                    payday={formatYearMonth(billingInfo?.payday || new Date())}
                    amount={billingInfo?.amount || 0}
                    onClose={onClose}
                />
            </div>
            {/*결제 통계 그래프*/}
            {paymentView()}
        </div>
    );
};

export default ClientBilling;